export enum ShipmentStatusEnum {
    QUOTE = 'QUOTE',
    SUBMITTED = 'SUBMITTED',

    PREPARING = 'PREPARING',
    QUOTED = 'QUOTED',
    MANIFESTED = 'MANIFESTED',
    IN_TRANSIT = 'IN_TRANSIT',
    DELIVERED = 'DELIVERED',
    VOID = 'VOID',
    EXCEPTION = 'EXCEPTION',
    PENDING = 'PENDING',

    ANY = 'ANY',
    ACTIVE = 'ACTIVE',

    QUOTING_IN_PROGRESS = 'QUOTING_IN_PROGRESS',
    QUOTING_COMPLETED = 'QUOTING_COMPLETED'
}

